import * as React from 'react';
import { connect } from 'react-redux';

import ClientApproval from '../client-approval/ClientApproval';
import ClientApprovalV2 from '../client-approval-v2/ClientApprovalV2';

import { fetchCampaign } from 'modules/shared-access/reducers/clientApproval';

import type { ClientApprovalCampaign } from 'types';

type OwnProps = {};

type StateProps = {
  campaign: ClientApprovalCampaign | undefined | null
};

type DispatchProps = {
  dispatchFetchCampaign: () => Promise<void>
};

type Props = OwnProps & StateProps & DispatchProps;

const ClientApprovalWrapper = ({ campaign, dispatchFetchCampaign }: Props): JSX.Element | null => {
  React.useEffect(() => {
    dispatchFetchCampaign();
  }, []);

  if (!campaign) {
    return null;
  }

  if (campaign.contentApprovalV2) {
    return <ClientApprovalV2 />;
  }

  return <ClientApproval />;
};

const mapStateToProps = ({ clientApproval }): StateProps => ({
  campaign: clientApproval.campaign
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchFetchCampaign: () => dispatch(fetchCampaign())
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientApprovalWrapper);
